import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { FormSection } from 'redux-form';
import { propFunc, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
const InterviewCandidatesFieldArray = (props) => {
    const { fields, render, title } = props;
    const onClickAdd = useCallback(() => {
        fields.push({ interviewDate: '', interviewTime: '' });
    }, [fields]);
    const onClickDelete = useCallback((e) => {
        const index = parseInt(e.currentTarget.value, 10);
        fields.remove(index);
    }, [fields]);
    return (_jsxs("div", Object.assign({ className: 'field field_interview_candidates' }, { children: [_jsx("div", Object.assign({ className: 'label' }, { children: title })), _jsx("hr", { className: 'divider' }), _jsx("ul", Object.assign({ className: 'interview_list' }, { children: fields.map((field, index) => (
                // eslint-disable-next-line react/no-array-index-key
                _jsx("li", Object.assign({ className: 'interview_list_row' }, { children: _jsx(FormSection, Object.assign({ name: `${fields.name}.${index}` }, { children: render({
                            field,
                            index,
                            isOne: fields.length === 1,
                            onClickDelete,
                        }) })) }), index))) })), _jsx("hr", { className: 'divider' }), _jsx("div", Object.assign({ className: 'interview_add_row' }, { children: _jsxs("label", Object.assign({ className: 'button_box' }, { children: [_jsx("button", Object.assign({ className: 'add_button', onClick: onClickAdd, type: 'button' }, { children: _jsx("i", { className: 'material-icons add' }) })), _jsx("span", Object.assign({ className: 'button_text' }, { children: "\u5019\u88DC\u65E5\u6642\u3092\u8FFD\u52A0" }))] })) })), _jsx("hr", { className: 'divider' })] })));
};
InterviewCandidatesFieldArray.propTypes = {
    fields: propShape().isRequired,
    render: propFunc().isRequired,
    title: propStr().isRequired,
};
export default InterviewCandidatesFieldArray;
